import assert from '../utils/assert';
import { global } from '../utils/globals';
export function encodeImage(image, type) {
  if (global._encodeImageNode) {
    return global._encodeImageNode(image, type);
  }

  if (image instanceof HTMLCanvasElement) {
    var _canvas = image;
    return _canvas.toDataURL(type);
  }

  assert(image instanceof Image, 'getImageData accepts image or canvas');
  var canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  canvas.getContext('2d').drawImage(image, 0, 0);
  var data = canvas.toDataURL(type || 'png').replace(/^data:image\/(png|jpg);base64,/, '');
  return Promise.resolve(data);
}
//# sourceMappingURL=encode-image.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/addons/node_modules/@loaders.gl/images/dist/esm/lib/encode-image.js
// module id = 1572
// module chunks = 0